export const refreshHeaderOptionToken = () => {
  let option: any;
  let optionPlane: any;
  const authUserData = localStorage.getItem("authUser");
  let authUser = null;
  
  try {
    if (authUserData) {
      // If authUserData is already an object, use it directly
      if (typeof authUserData === 'object') {
        authUser = authUserData;
      } else {
        // If it's a string, try to parse it
        authUser = JSON.parse(authUserData);
      }
    }
  } catch (e) {
    console.error('Failed to parse authUser:', e);
  }

  if (authUser && authUser.token) {
    option = {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${authUser.token}`,
    };
  } else {
    option = {
      "Content-Type": "application/json; charset=utf8",
    };
  }
  return { option, optionPlane };
};
